import $ from 'jquery'

class ProductsController {
  constructor (ProductService, VehicleService, DeviceService, MetricsService, I18n, $scope, $log, $timeout, $state, $rootScope) {
    'ngInject'
    this.isProcessing = true
    this.vehicleService = VehicleService
    this.productService = ProductService
    this.deviceService = DeviceService
    this.metricsService = MetricsService
    this.i18n = I18n
    this.$log = $log
    this.$rootScope = $rootScope
    this.$scope = $scope
    this._filter = 'all'

    $scope.$on('width:resized', () => {
      $log.debug('width resized fired')
      $timeout(() => {
        $state.reload()
      })
    })

    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle()
      .then((vehicle) => {
        if (!vehicle) {
          this.$log.error('Unable to get current selected vehicle.')
          return Promise.reject('Unable to get current selected vehicle.')
        }
        this.vehicle = vehicle
        this.fetchProducts()
      })
  }

  get nbItemPerPage () {
    if (this.deviceService.isSmallScreen()) {
      return 4
    } else if (this.deviceService.isMediumScreen()) {
      return 6
    }
    return 8
  }

  set filter (filter) {
    this.pageIndex = 0
    if (this._filter !== filter) {
      this._filter = filter
      if (this.category) {
        this.fetchProducts()
      }
    }
  }

  get filter () {
    return this._filter
  }

  set category (category) {
    if (!this._category || this._category.id !== category.id) {
      this._category = category
      this.fetchProducts()
    }
  }

  get category () {
    return this._category
  }

  fetchProducts () {
    if (!this.category || !this.vehicle) {
      return null
    }
    this.isProcessing = true
    const params = {
      locale: this.i18n.getLanguage(),
      category: this.category.id,
      filter: this.filter,
      vin: this.vehicle.vin,
      devicename: this.vehicle.deviceName,
      deviceversion: this.vehicle.deviceVersion,
      nbItemPerPage: 1000,
      page: 1,
      order: 'asc'
    }
    this.productService.getProducts(params)
    .then((products) => {
      const nbItemPerPage = this.nbItemPerPage
      const _products = products.items.map((product) => {
        if (product.group) {
          product.group = product.group.sort((a, b) => (parseFloat(a.price.slice(0, -4))) - (parseFloat(b.price.slice(0, -4))))
          const group = product.group
          product = Object.assign({}, product.group[0])
          product.group = group
        }
        return {
          ...product,
          sref: `product.detail({id: '${product.id}'})`
        }
      })
      const pages = []
      while (_products.length > 0) {
        const chunk = _products.splice(0, nbItemPerPage)
        pages.push(chunk)
      }
      this.pages = pages
      this.isProcessing = false
      this.error = null
      this.safeApply()
      return this.metricsService.endPageLoadTime(200)
    }, (err) => {
      this.isProcessing = false
      this.$log.error(err)
      this.error = err
      this.safeApply()
      return this.metricsService.endPageLoadTime(500)
    })
  }

  previousIndex () {
    this.hideProductDurationTooltip()
    this.pageIndex --
  }

  nextIndex () {
    this.hideProductDurationTooltip()
    this.pageIndex ++
  }

  hideProductDurationTooltip () {
    this.$rootScope.$broadcast('productDurationTooltip:closed')
    $('products .product-pages > ul').css('overflow', 'hidden')
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }
}

export default ProductsController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/products/products.controller.js